import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

import { Spinner } from './Spinner';

type Variant = 'primary' | 'outline' | 'text' | 'danger' | 'pill';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  block?: boolean;
  loading?: boolean;
  children: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = 'primary',
    block = false,
    loading = false,
    disabled,
    children,
    className,
    type = 'button',
    ...rest
  },
  ref,
): JSX.Element {
  const classes = ['btn', `btn--${variant}`, block ? 'btn--block' : '', className ?? '']
    .filter(Boolean)
    .join(' ');

  return (
    // eslint-disable-next-line react/button-has-type -- type is constrained above
    <button ref={ref} className={classes} disabled={disabled ?? loading} type={type} {...rest}>
      {loading ? <Spinner /> : children}
    </button>
  );
});
